/* @flow */
import * as React from 'react';
import ScrollableArea from 'components/ScrollableArea';

import './styles/StreamScrollableArea.scss';

type Props = {
  children: React.Node,
  onScrollToBottom?: () => void,
};

class StreamScrollableArea extends React.Component<Props, void> {
  ScrollableArea: ScrollableArea;

  scrollToBottom() {
    if (this.ScrollableArea) {
      // this is sometimes being called in ChatStreamContainer and
      // AnnouncementStreamContainer before ScrollableArea has rendered
      this.ScrollableArea.scrollToBottom();
    }
  }

  render() {
    return (
      <div className="StreamScrollableArea">
        <ScrollableArea
          onScrollToBottom={this.props.onScrollToBottom}
          ref={(a: any) => (this.ScrollableArea = a)}
          useBodyChildrenHeight
          scrollToBottom>
          {this.props.children}
        </ScrollableArea>
      </div>
    );
  }
}

export default StreamScrollableArea;
